function closePopupMobileMenu(target) {
    const popupMobileMenu = target.closest('.mobile-menu.show')
    if (popupMobileMenu) {
        popupMobileMenu.querySelector('.js-popup-close').click()
    }
}
